// @ts-check
import { nextArrow, prevArrow, options } from "@/global/slick-options";
import { getAll } from "@/utilities/querySelector";


/**
 * @param {HTMLElement} slider
 */
export function slick(slider) {
    const size = slider.getAttribute("data-card-slider");
    const additionalOptions = JSON.parse(slider.getAttribute('data-slider-options') ?? '{}');

    let customOptions = {};
    let defaultOptions = {
        ...options,
        nextArrow,
        prevArrow
    };

    if (size === "tiny") {
        customOptions = {
            ...defaultOptions,
            slidesToShow: 2,
            responsive: [
                {
                    breakpoint: 400,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 650,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 5,
                    }
                },
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 6,
                    }
                },
            ],
        };
    } else if (size === "small") {
        customOptions = {
            ...defaultOptions,
            responsive: [
                {
                    breakpoint: 580,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1050,
                    settings: {
                        slidesToShow: 4,
                    }
                },
            ],
        };
    } else if (size == "medium") {
        customOptions = {
            ...defaultOptions,
            responsive: [
                {
                    breakpoint: 580,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 3,
                    }
                },
            ],
        };
    } else if (size == "large") {
        customOptions = {
            ...defaultOptions,
            responsive: [
                {
                    breakpoint: 824,
                    settings: {
                        slidesToShow: 2.5,
                    }
                },
            ],
        };
    } else if (size == "huge") {
        customOptions = {
            ...defaultOptions,
            fade: true,
        };
    }

    jQuery(slider).slick({
        ...customOptions,
        ...additionalOptions
    });
}

/**
 * Un-slicks the darned slider
 * @param {HTMLElement} slider
 */
export function unslick(slider) {
    jQuery(slider).slick('unslick');
}


document.addEventListener('DOMContentLoaded', () => {
    const sliders = getAll('[data-card-slider]');
    if (sliders.length) {
        sliders.forEach((slider) => {
            if (slider.hasAttribute('data-defer-init')) return;
            slick(slider);
        });
    }
});